<style lang="less" scoped>
  .title-div {
    font-weight: 600;
    margin: 10px 0 10px;
    font-size: 26px;
    flex-grow: 1;
    color: #000;
    height: 30px;
  }
  .pileItem-div {
    font-weight: 600;
    //   margin: 0 10px !important;
    font-size: 20px;
    // flex-grow: 1;
    color: #000;
    // height: 30px;
  }
  .el-col {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    margin: 10px 0;
    > div:first-of-type {
      text-align: left;
      font-size: 14px;
      font-weight: 400;
      width: 120px;
      line-height: 32px;
    }
    > div:last-of-type {
      flex: 1;
      font-size: 14px;
      min-width: 160px;
      line-height: 32px;
    }
  }

  .cust-detail-title {
    width: 120px;
    line-height: 32px;
    font-weight: 700;
  }
  .cust-detail-value {
    flex: 1;
    line-height: 32px;
    word-break: break-all;
    display: flex;
    // justify-content: center;
    align-items: center;
  }

  .margin-r-10 {
    margin-right: 10px;
  }

  .flex-orderno-line-div {
    display: flex;
    border-bottom: 1px solid #555;
    padding-bottom: 16px;
    margin-bottom: 16px;

    .line-child-order-no-title {
      font-weight: 600;
      font-size: 26px;
      color: #000;
      height: 30px;
      margin-right: 60px;
    }
    .line-child-order-no-value {
      font-weight: 600;
      font-size: 26px;
      color: #000;
      height: 30px;
      flex: 1;
    }
  }

  .padding-top-10 {
    padding-top: 10px;
  }
</style>

<template>
  <div class="detail-container">
    <div class="detail-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="detailBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="detail-content-div">
      <div class="detail-content-header-div flex">
        <div class="left-page-title-div flex-1">{{ pageTitle }}</div>
      </div>
      <div class="detail-content-body-div flex-1">
        <div class="flex-orderno-line-div">
          <div class="line-child-order-no-title">订单编号</div>
          <div class="line-child-order-no-value">
            {{ detailForm.activityOrderNo }}
          </div>
          <div class="line-child-submit-btns-div">
            <!-- 售后换桩: 仅使用中(02)显示;取消换桩: 换桩中(06)显示,用户在小程序解绑旧桩后不可取消 -->
            <button class="common-bg-button margin-r-10" @click="onPileSwapInitiate()" v-if="detailForm.orderStatus === '02'">
              售后换桩
            </button>
            <button class="common-bg-button margin-r-10" @click="onPileSwapCancel()" v-if="detailForm.orderStatus === '06' && !pileSwapUnbound">
              取消换桩
            </button>
            <el-tooltip v-if="detailForm.orderStatus === '06' && pileSwapUnbound" content="用户已解绑,无法取消" placement="top">
              <button class="common-bg-button margin-r-10" disabled>取消换桩</button>
            </el-tooltip>
            <button class="common-bg-button margin-r-10" @click="submit()">
              保 存
            </button>
            <button class="common-bg-button" @click="back()">返 回</button>
          </div>
        </div>

        <!-- 页签结构对齐安心包598:订单信息为主页签,换桩记录为独立页签(切换时才挂载组件并调接口) -->
        <el-tabs v-model="pileSwapMainTab" type="card">
          <el-tab-pane label="订单信息" name="order">

        <div class="title-div">订单基本信息</div>

        <el-row :gutter="20">
          <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
            <div class="cust-detail-title">用户姓名</div>
            <div class="cust-detail-value">{{ detailForm.name }}</div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
            <div class="cust-detail-title">用户手机号</div>

            <div class="cust-detail-value">
              <span v-if="isFlag">{{ detailForm.mobile }}</span>
              <span v-else>
                {{detailForm.mobile ? detailForm.mobile.replace(detailForm.mobile.substring(2, 9), "*******") : ""}}
              </span>
              <img style="width:20px;height:20px;" src="../../../assets/app-card-style/眼睛_隐藏.png" alt="" v-if="isFlag == false" @click="flagChange()"/>
              <img style="width:20px;height:20px;" src="../../../assets/app-card-style/眼睛_显示.png" alt="" v-if="isFlag == true" @click="flagChange()"/>
            </div>

          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
            <div class="cust-detail-title">订单状态</div>
            <div class="cust-detail-value">
              {{ detailForm.orderStatusName }}
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
            <div class="cust-detail-title">支付流水号</div>
            <div class="cust-detail-value">
              {{ detailForm.payTransactionNo }}
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
            <div class="cust-detail-title">退款流水号</div>
            <div class="cust-detail-value">
              {{ detailForm.refundTransactionNo }}
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
            <div class="cust-detail-title">创建时间</div>
            <div class="cust-detail-value">
              {{ detailForm.createdWhen }}
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
            <div class="cust-detail-title">绑定时间</div>
            <div class="cust-detail-value">{{ detailForm.bindTime }}</div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
            <div class="cust-detail-title">充电桩编码</div>
            <div class="cust-detail-value">
              {{ detailForm.pileCode }}
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
            <div class="cust-detail-title">激活状态</div>
            <div class="cust-detail-value">
              {{ detailForm.activateStatusName }}
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
            <div class="cust-detail-title">分享状态</div>
            <div class="cust-detail-value">
              <span v-if="detailForm.shareStatus === '01'">{{ '已分享' }}</span>
              <span v-else-if="detailForm.shareStatus === '02'">{{ '未分享' }}</span>
              <span v-else>{{ '' }}</span>
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
            <div class="cust-detail-title">分享类型</div>
            <div class="cust-detail-value">
              <span v-if="detailForm.shareType === '01'">{{ '报名分享' }}</span>
              <span v-else-if="detailForm.shareType === '02'">{{ '支付分享' }}</span>
              <span v-else-if="detailForm.shareType === '03'">{{ '双重分享' }}</span>
              <span v-else>{{ '' }}</span>
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
            <div class="cust-detail-title">礼品领取状态</div>
            <div class="cust-detail-value">
              <span v-if="detailForm.giftStatus === '01'">{{ '已领取' }}</span>
              <span v-else-if="detailForm.giftStatus === '02'">{{ '未领取' }}</span>
              <span v-else>{{ '' }}</span>
            </div>
          </el-col>
          <!-- 订单属性 -->
          <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
            <div class="cust-detail-title">充电桩启用时间</div>
            <div class="cust-detail-value">
              {{ detailForm.periodStartTime }}
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
            <div class="cust-detail-title">充电桩到期时间</div>
            <el-date-picker
              v-model="detailForm.periodEndTime"
              type="datetime"
              size="small"
              prefix-icon="el-icon-date"
              value-format="yyyy-MM-dd HH:mm:ss"
              @change="changeTime(detailForm.periodEndTime)"
              placeholder="选择日期时间"
            >
            </el-date-picker>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
            <div class="cust-detail-title">购买名称</div>
            <div class="cust-detail-value">{{ detailForm.orderName || '' }}</div>
          </el-col>
          <el-col :xs="6" :sm="6" :md="6" :lg="12" class="flex">
            <div class="cust-detail-title">省市区</div>
            <!-- <Area
              :showLevel="3"
              @updateSelAreas="updateSelAreas"
              :selProvince="detailForm.province"
              :selCity="detailForm.city"
              :selArea="detailForm.area"
            /> -->
            <el-cascader
                size="small"
                clearable
                ref="cascader"
                :options="options"
                v-model="detailForm.selectedOptions"
                @change="handleChange"

              >
              </el-cascader>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
            <div class="cust-detail-title">详细地址</div>
            <el-input
              v-model="detailForm.address"
              placeholder=""
              maxlength="50"
              size="small"
            ></el-input>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="8" class="flex">
            <div class="cust-detail-title">车辆型号</div>
            <el-input
              v-model="detailForm.vehicleModel"
              placeholder=""
              maxlength="50"
              size="small"
            ></el-input>
          </el-col>
        </el-row>

        <div class="title-div">支付宝权益领取记录</div>

        <div class="padding-top-10"></div>

        <el-tabs v-model="activeName" type="card">
          <el-tab-pane label="洗车券" name="first">
            <el-table
              class="el-table"
              :data="xcCardList"
              border
              max-height="500px"
              style="width: 100%; margin: 20px auto"
              :cell-style="{ 'text-align': 'center' }"
              :header-cell-style="{
                background: '#FAFAFA',
                color: '#8F9BB3',
                fontSize: '14px',
                textAlign: 'center',
                border: '1px solid #F0F0F0',
              }"
            >
              <el-table-column prop="couponExchangeNo" label="兑换流水号">
              </el-table-column>
              <el-table-column prop="couponNo" label="券码"> </el-table-column>
              <el-table-column prop="prizeAmount" label="券值">
              </el-table-column>
              <el-table-column prop="exchangeSuccessWhen" label="兑换时间">
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="公共充电券" name="second">
            <el-table
              class="el-table"
              :data="ggcdCardList"
              border
              max-height="500px"
              style="width: 100%; margin: 20px auto"
              :cell-style="{ 'text-align': 'center' }"
              :header-cell-style="{
                background: '#FAFAFA',
                color: '#8F9BB3',
                fontSize: '14px',
                textAlign: 'center',
                border: '1px solid #F0F0F0',
              }"
            >
              <el-table-column prop="couponExchangeNo" label="兑换流水号">
              </el-table-column>
              <el-table-column prop="couponNo" label="券码"> </el-table-column>
              <el-table-column prop="prizeAmount" label="券值">
              </el-table-column>
              <el-table-column prop="exchangeSuccessWhen" label="兑换时间">
              </el-table-column> </el-table
          >
          </el-tab-pane>
          <el-tab-pane label="租车券" name="third">
            <el-table
              class="el-table"
              :data="zcCardList"
              border
              max-height="500px"
              style="width: 100%; margin: 20px auto"
              :cell-style="{ 'text-align': 'center' }"
              :header-cell-style="{
                background: '#FAFAFA',
                color: '#8F9BB3',
                fontSize: '14px',
                textAlign: 'center',
                border: '1px solid #F0F0F0',
              }"
            >
              <el-table-column prop="couponExchangeNo" label="兑换流水号">
              </el-table-column>
              <el-table-column prop="couponNo" label="券码"> </el-table-column>
              <el-table-column prop="prizeAmount" label="券值">
              </el-table-column>
              <el-table-column prop="exchangeSuccessWhen" label="兑换时间">
              </el-table-column> </el-table
          >
          </el-tab-pane>
          <el-tab-pane label="代驾券" name="fourth">
            <el-table
              class="el-table"
              :data="djCardList"
              border
              max-height="500px"
              style="width: 100%; margin: 20px auto"
              :cell-style="{ 'text-align': 'center' }"
              :header-cell-style="{
                background: '#FAFAFA',
                color: '#8F9BB3',
                fontSize: '14px',
                textAlign: 'center',
                border: '1px solid #F0F0F0',
              }"
            >
              <el-table-column prop="couponExchangeNo" label="兑换流水号">
              </el-table-column>
              <el-table-column prop="couponNo" label="券码"> </el-table-column>
              <el-table-column prop="prizeAmount" label="券值">
              </el-table-column>
              <el-table-column prop="exchangeSuccessWhen" label="兑换时间">
              </el-table-column></el-table
          >
          </el-tab-pane>
        </el-tabs>

        <div class="title-div">续约流水</div>
        <div class="xy-table-div">
          <el-table
            class="el-table"
            :data="xyPayList"
            border
            max-height="500px"
            style="width: 100%; margin: 20px auto"
            :cell-style="{ 'text-align': 'center' }"
            :header-cell-style="{
              background: '#FAFAFA',
              color: '#8F9BB3',
              fontSize: '14px',
              textAlign: 'center',
              border: '1px solid #F0F0F0',
            }"
          >
            <!-- <el-table-column prop="activityOrderNo" label="续约订单号">
            </el-table-column> -->
            <el-table-column prop="transactionNo" label="支付流水号">
            </el-table-column>
            <el-table-column prop="transactionChannelName" label="支付渠道">
            </el-table-column>
            <el-table-column prop="createdWhen" label="支付时间">
            </el-table-column>
            <el-table-column prop="timeInterval" label="续约时间范围">
            </el-table-column>
          </el-table>
        </div>

        <div class="title-div">备注</div>

        <div class="remark-info-div padding-top-10">
          <el-input
            v-model="detailForm.remark"
            type="textarea"
            :rows="6"
          ></el-input>
        </div>

          </el-tab-pane>

          <!-- 老499售后换桩记录(含取消操作,取消后刷新订单详情) -->
          <el-tab-pane label="换桩记录" name="pileSwap">
            <Old499PileSwapRecordTable
              v-if="pileSwapMainTab === 'pileSwap'"
              :activityorderNo="detailForm.activityOrderNo"
              @refresh="init"
            />
          </el-tab-pane>
        </el-tabs>

      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from "./page-config";
import Area from "../../../components/area-select/index.vue";
import Old499PileSwapRecordTable from "./pile-swap-record-table.vue";
import { codeToText, regionData, TextToCode,pcaTextArr } from "element-china-area-data"; //导入地图数据
export default {
  components: {
    Area,
    Old499PileSwapRecordTable,
  },
  data() {
    var self = this;
    return {
      options:pcaTextArr,
      pageConfig,
      activityOrderId: "",
      editFlag: false,
      pageTitle: "活动订单编辑",
      tableData: [], // 表格数据
      selections: [], // 表格选项
      pagination: pageConfig.pagination,
      queryInfo: {},
      // 默认值设置
      detailForm: {
        selectedOptions:[],
      },
      repairForm: {},
      activeName: "first",
      // 页面主页签(对齐安心包598):order=订单信息,pileSwap=换桩记录
      pileSwapMainTab: "order",
      time: [],
      pileGunNum: "",
      pileStatusEntity: {},
      url: "",
      mainTitle: "",
      dialogFormVisible: false,
      xcCardList: [],
      ggcdCardList: [],
      zcCardList: [],
      djCardList: [],
      xyPayList: [],
      detailBreadCrumb: [],
      isFlag: false,
      // 换桩中(06)时用户是否已解绑旧桩: 已解绑则web端无法取消换桩,只能等用户绑新桩
      pileSwapUnbound: false,
    };
  },
  methods: {
     // 地图
     handleChange(e) {
      console.log(e);
      //因为上边选择好城市之后打印出来的是编码，这里是将编码转换为文字
      // let arr = ['北京市','11101']

    //  console.log(TextToCode[arr[0]]);
      let province = this.detailForm.selectedOptions[0]; //省
      let city = this.detailForm.selectedOptions[1]; //市
      let county = this.detailForm.selectedOptions[2]; //区(三级联动带区的话可以加上这个，二级联动不需要这个)
      // if (city == "市辖区") {
      //   //选择北京市的话，第二个选项为输入框
      //   city = province; //这里根据后台需求，给它赋值，我这里是如果为市辖区，城市和省名字保持一致
      // }
      //这里是请求赋值
      this.detailForm.province = province;
      this.detailForm.city = city;
      this.detailForm.area = county; //三级联动带区可以加上，二级联动(省市)不需要
      console.log(this.formInfo);
    },
    flagChange() {
      this.isFlag = !this.isFlag;
      // if (this.isFlag) {
      //   this.isFlag = false;
      // } else {
      //   this.isFlag = true;
      // }
      console.log(this.isFlag);
    },
    updateSelAreas(val) {
      console.log(val);
      this.detailForm.province = val.province;
      this.detailForm.city = val.city;
      this.detailForm.area = val.area;
    },
    init() {
      let _ = this;
      this.mainTitle = "活动订单编辑";
      this.detailBreadCrumb = this.pageConfig.detailBreadCrumb;
      _.$H.post(_, _.$A.activityOrder.findByNo, {activityOrderId: this.activityOrderId,}).then((res) => {
        _.detailForm = res.data.data || {};
        _.xcCardList = _.detailForm.exchangeWashList || [];
        _.ggcdCardList = _.detailForm.exchangeChargeList || [];
        _.zcCardList = _.detailForm.exchangeCarList || [];
        _.djCardList = _.detailForm.exchangeDriveList || [];
        _.xyPayList = [];
        const transactionRecordList = _.detailForm.transactionRecordList || [];
        transactionRecordList.forEach((t) => {
          if ("02" == t.buyType) {
            _.xyPayList.push(t);
          }
        });
        if (this.detailForm.city == this.detailForm.province) {
          this.detailForm.city = '市辖区'
        }
        //  城市文字转编码
        if (this.detailForm.province != '' && this.detailForm.city != '') {
          this.detailForm.selectedOptions = [this.detailForm.province,this.detailForm.city,this.detailForm.area]
        }
          _.$U.hideLoading(_);
          // 换桩中订单需判断用户是否已解绑旧桩(决定取消按钮是否可点)
          _.fetchPileSwapUnbound();
        });
    },
    // 查询进行中换桩记录的解绑状态(换桩记录接口与安心包通用,仅查记录表)
    fetchPileSwapUnbound() {
      let _ = this;
      if (_.detailForm.orderStatus !== '06') {
        _.pileSwapUnbound = false;
        return;
      }
      _.$H.post(_, _.$A.activityOrder.axbPileSwapRecordList, {
        activityOrderNo: _.detailForm.activityOrderNo,
      }).then((res) => {
        const list = (res && res.data && res.data.status === 200 && res.data.data) || [];
        const swapping = list.find((r) => r.swapStatus === 'SWAPPING');
        _.pileSwapUnbound = !!swapping && !!swapping.unbindTime;
      }).catch(() => {
        _.pileSwapUnbound = false;
      });
    },
    // 发起售后换桩: 订单状态使用中(02) -> 换桩中(06)
    onPileSwapInitiate() {
      let _ = this;
      _.$confirm('确认对该订单发起售后换桩?发起后订单状态变为换桩中,需用户在小程序解绑旧桩并绑定新桩。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        _.$H.post(_, _.$A.activityOrder.old499PileSwapInitiate, {
          activityOrderNo: _.detailForm.activityOrderNo,
        }).then((res) => {
          if (res && res.data && res.data.status === 200) {
            _.$message.success('已发起换桩');
            _.init();
          } else {
            _.$message.error((res && res.data && res.data.message) || '发起换桩失败');
          }
        }).catch(() => _.$message.error('发起换桩失败'));
      }).catch(() => {});
    },
    // 取消售后换桩: 订单状态换桩中(06) -> 使用中(02)
    onPileSwapCancel() {
      let _ = this;
      _.$confirm('确认取消该次换桩?取消后订单状态将恢复为使用中。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        _.$H.post(_, _.$A.activityOrder.old499PileSwapCancel, {
          activityOrderNo: _.detailForm.activityOrderNo,
        }).then((res) => {
          if (res && res.data && res.data.status === 200) {
            _.$message.success('已取消换桩');
            _.init();
          } else {
            _.$message.error((res && res.data && res.data.message) || '取消换桩失败');
          }
        }).catch(() => _.$message.error('取消换桩失败'));
      }).catch(() => {});
    },
    //判断开始结束时间是否选择早于/晚于结束开始时间
    disabledDate(time) {
      let _ = this;
      if (time < this.detailForm.beginTime) {
        _.$U.error("选择时间不能早于充电开始时间");
        this.detailForm.endTime = "";
        return false;
      } else if (time > this.detailForm.endTime) {
        _.$U.error("选择时间不能晚于充电结束时间");
        this.detailForm.beginTime = "";
        return false;
      } else {
        return true;
      }
    },
    changeTime(time) {
      let _ = this;
      //true的话 根据选择的开始结束时间算出时间间隔,并转换为XX分钟
      if (this.disabledDate(time)) {
        if (
          _.$U.notEmpty(this.detailForm.beginTime) &&
          _.$U.notEmpty(this.detailForm.endTime)
        ) {
          let start = new Date(
            this.detailForm.beginTime.replace("-", "/").replace("-", "/")
          );
          let end = new Date(
            this.detailForm.endTime.replace("-", "/").replace("-", "/")
          );
          let date3 = new Date(end).getTime() - start.getTime();

          let days = Math.floor(date3 / (24 * 3600 * 1000));
          let leave1 = date3 % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
          let hours = Math.floor(leave1 / (3600 * 1000));
          //计算相差分钟数
          let leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
          let minutes = Math.floor(leave2 / (60 * 1000));
          //计算相差秒数
          let leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
          let seconds = Math.round(leave3 / 1000);
          if (days > 0) {
            hours = hours + 24 * days;
          } else {
            hours = hours;
          }
          if (hours > 0) {
            minutes = minutes + 60 * hours;
          } else {
            minutes = minutes;
          }
          if (seconds > 0) {
            minutes = minutes + 1;
          } else {
            minutes = minutes;
          }
          _.detailForm.chargeMin = minutes;
        }
      }
    },
    //修改订单金额
    changeFee(fee) {
      let _ = this;
      _.detailForm.actPayFee = fee;
    },
    //修改订单金额
    submit() {
      let _ = this;
      // if(_.$U.isEmpty(_.detailForm.periodEndTime)){
      //   _.$U.error("请选择充电桩到期时间！");
      //   return
      // }
      _.$H.post(_, _.$A.activityOrder.edit, _.detailForm).then((res) => {
        _.$U.success("修改成功！");
        _.$router.push({
          name: "old499ActivityOrderList",
        });
      });
    },
    back() {
      this.$router.go(-1);
    },
  },
  mounted() {
    this.activityOrderId = this.$route.query.orderId;
    this.init();
  },
};
</script>
